/*
 * MMC: legacy Suit "minicart" built on the Prestige "message" cart type (snippets/suit-cart-message.liquid).
 *
 * Prestige dispatches "variant:add" (bubbling) after a successful add to cart, with the added line items. The popup is
 * filled with all the cart lines rendered by sections/suit-cart-message.liquid (Liquid money formatting), the lines
 * just added first, with at most one and a half lines visible and the rest scrolling, the cart total and the number of
 * items, then shown: below the header on desktop, as a bottom sheet on mobile (assets/suit.css). It closes with the
 * close button, a click on the overlay / outside, Escape, or by itself after 5 seconds unless hovered / touched.
 */
(() => {
  const popup = document.querySelector('.suit-cart-message');

  if (!popup || window.__suitCartMessage) {
    return;
  }

  window.__suitCartMessage = true;

  const itemsSlot = popup.querySelector('.suit-cart-message__items');
  const totalSlot = popup.querySelector('.suit-cart-message__total-slot');
  const countSlot = popup.querySelector('.suit-cart-message__count-slot');

  // As the legacy minicart: closes by itself after 5 seconds, unless the customer hovers or touches it
  const AUTO_CLOSE_DELAY = 5000;
  let autoCloseTimer = null;

  const cancelAutoClose = () => {
    clearTimeout(autoCloseTimer);
    autoCloseTimer = null;
  };

  const close = () => {
    cancelAutoClose();
    popup.classList.remove('is-open');
    document.documentElement.classList.remove('suit-cart-message-open');
    setTimeout(() => {
      if (!popup.classList.contains('is-open')) {
        popup.hidden = true;
      }
    }, 300);
  };

  // At most one and a half products are visible (the half one hints that the list scrolls), so the popup stays compact
  const limitVisibleItems = () => {
    requestAnimationFrame(() => {
      const items = itemsSlot.querySelectorAll('.suit-cart-message__item');

      if (items.length < 2) {
        itemsSlot.style.removeProperty('max-height');
        return;
      }

      const first = items[0].getBoundingClientRect();
      const second = items[1].getBoundingClientRect();
      itemsSlot.style.maxHeight = `${Math.ceil(second.top - first.top + second.height / 2)}px`;
    });
  };

  // Desktop: just below the cart icon, as the legacy minicart (CSS falls back to below the sticky header)
  const placeBelowCartIcon = () => {
    const icon = document.querySelector('.header__cart-link');
    const bottom = icon?.getBoundingClientRect().bottom;

    if (bottom) {
      popup.style.setProperty('--suit-cart-message-top', `${Math.round(bottom + 12)}px`);
    }
  };

  const open = () => {
    placeBelowCartIcon();
    popup.hidden = false;
    requestAnimationFrame(() => {
      popup.classList.add('is-open');
      document.documentElement.classList.add('suit-cart-message-open');
    });
  };

  document.addEventListener('variant:add', async (event) => {
    const keys = (event.detail?.items || []).map((item) => item.key);

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}?section_id=suit-cart-message`);

      if (!response.ok) {
        return;
      }

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      // Every cart line, consistent with the total: the lines just added first, then the others
      const lines = [...html.querySelectorAll('.suit-cart-message__item')];
      const added = lines.filter((line) => keys.includes(line.dataset.key));
      const others = lines.filter((line) => !keys.includes(line.dataset.key));

      itemsSlot.replaceChildren(...[...added, ...others].map((line) => document.importNode(line, true)));
      itemsSlot.scrollTop = 0;
      totalSlot.textContent = html.querySelector('.suit-cart-message__total-value')?.textContent.trim() || '';
      countSlot.textContent = `(${html.querySelector('.suit-cart-message__count-value')?.textContent.trim() || lines.length})`;
      open();
      limitVisibleItems();

      cancelAutoClose();
      autoCloseTimer = setTimeout(close, AUTO_CLOSE_DELAY);
    } catch (error) {
      // Network error: the product is in the cart anyway, the header counter is updated by Prestige
    }
  });

  popup.querySelector('.suit-cart-message__panel').addEventListener('mouseenter', cancelAutoClose);
  popup.querySelector('.suit-cart-message__panel').addEventListener('touchstart', cancelAutoClose, { passive: true });

  popup.addEventListener('click', (event) => {
    if (event.target.closest('[data-suit-cart-message-close]')) {
      close();
    }
  });

  document.addEventListener('click', (event) => {
    if (popup.classList.contains('is-open') && !popup.contains(event.target)) {
      close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      close();
    }
  });
})();
